import * as React from 'react';

type Props = {
  url: string;
  displayText: string;
};

export const InterAppLink: React.FC<Props> = ({ url, displayText }) => <a href={url}>{displayText}</a>;
